import { FC } from 'react'

import { AppDialog } from '@/components/AppDialog'
import { Button } from '@/components/ui/button'
import contactIcon from '@/imgs/chat-3.svg'

interface ContactUsProps {
  show: boolean
  setShow: (show: boolean) => void
}

const WhatsAppIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512' className='h-8 w-8'>
    <path
      fill='currentColor'
      d='M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z'
    />
  </svg>
)

const EmailIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 512' className='h-8 w-8'>
    <path
      fill='currentColor'
      d='M560 32h-384C149.5 32 128 53.49 128 80v1.311l212.5 164.1c16.2 12.6 38.87 12.6 55.06 0L608 81.31V80C608 53.49 586.5 32 560 32zM368 288c-16.53 0-33.06-5.484-47.16-16.47L128 121.3V336C128 362.5 149.5 384 176 384h384c26.51 0 48-21.49 48-48V121.3l-192.8 150.2C401.1 282.5 384.5 288 368 288zM488 480H152C85.83 480 32 426.2 32 360v-240C32 106.8 42.75 96 56 96S80 106.8 80 120v240c0 39.7 32.3 72 72 72h336c13.25 0 24 10.75 24 24S501.3 480 488 480z'
    />
  </svg>
)

const InstagramIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512' className='h-8 w-8'>
    <path
      fill='currentColor'
      d='M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z'
    />
  </svg>
)

const FacebookIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512' className='h-8 w-8'>
    <path
      fill='currentColor'
      d='M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z'
    />
  </svg>
)

const contactLinks = [
  {
    href: 'https://wa.me/972559458872',
    icon: WhatsAppIcon,
    label: 'וואטסאפ',
  },
  {
    href: 'mailto:hello@shiptanbul.com',
    icon: EmailIcon,
    label: 'אימייל',
  },
  {
    href: 'https://www.instagram.com/shiptanbul/',
    icon: InstagramIcon,
    label: 'אינסטגרם',
  },
  {
    href: 'https://www.facebook.com/shiptanbul',
    icon: FacebookIcon,
    label: 'פייסבוק',
  },
]

export const ContactUs: FC<ContactUsProps> = ({ show, setShow }) => {
  return (
    <AppDialog
      isOpen={show}
      onOpenChange={setShow}
      title={
        <div className='flex flex-col items-center gap-6 px-6 pt-8 pb-4 text-center'>
          <img src={contactIcon} alt='Contact' className='hidden h-[72px] w-[72px] md:block' />
          <h2 className='text-text-primary text-2xl font-bold'>צרו איתנו קשר</h2>
        </div>
      }
    >
      <div className='flex flex-col items-center gap-6 px-6 pb-8 text-center'>
        <p className='text-text-secondary text-base leading-relaxed'>
          יש לכם שאלות? רוצים לדעת עוד? צריכים שנסייע לכם?
          <br />
          יותר מנשמח לעזור!!
        </p>

        <div className='flex flex-row-reverse flex-wrap items-center justify-center gap-6 md:gap-8'>
          {contactLinks.map(link => {
            const IconComponent = link.icon
            return (
              <a
                key={link.href}
                href={link.href}
                target='_blank'
                rel='noreferrer'
                className='group flex flex-col items-center gap-2 transition-transform hover:scale-105'
              >
                <div className='flex h-[60px] w-[60px] items-center justify-center rounded-full bg-[#fcde00] transition-colors group-hover:bg-[#fcd700] md:h-[72px] md:w-[72px]'>
                  <IconComponent />
                </div>
                <span className='text-text-primary text-sm font-medium'>{link.label}</span>
              </a>
            )
          })}
        </div>

        <div className='flex flex-col gap-4'>
          <p className='text-text-secondary text-sm leading-relaxed'>
            שעות הפעילות שלנו הן בימי ראשון עד חמישי מ- 10:00 ועד 17:00. בימי שישי מהשעה 9:00 ועד 13:00.
            <br />
            המשרד והמוקד סגורים בסופי שבוע וחגים.
          </p>
          <p className='text-text-secondary text-sm leading-relaxed'>
            בינתיים, כדאי לכם לבדוק את אזור השאלות והתשובות באתר ו/או את המדריך שייצרנו עבורכם על איך התהליך עובד.
            <br />
            אולי תמצאו שם את התשובה שאתם מחפשים!
          </p>
        </div>

        <a href='http://www.shiptanbul.com/knowledge-center/' target='_blank' rel='noreferrer' className='mt-2'>
          <Button variant='default' className='w-[180px]'>
            מרכז הידע והתמיכה
          </Button>
        </a>
      </div>
    </AppDialog>
  )
}
